import { v4 as uuid } from 'uuid';

const TAB_ID_KEY = 'bv:tabId';

const clearPersistedState = (): void => {
  Object.keys(sessionStorage)
    .filter((key) => key.startsWith('persist:'))
    .forEach((key) => sessionStorage.removeItem(key));
};

// sessionStorage is copied into a tab opened from an existing one, so on its own it cannot tell a
// reload apart from an inherited session: the customer resumes the parent tab's flow and lands
// mid-checkout with an empty cart. window.name survives a reload but is empty in a newly opened tab,
// which is what separates the two.
export const claimTabSession = (): void => {
  const ownerId = sessionStorage.getItem(TAB_ID_KEY);

  if (ownerId && window.name === ownerId) {
    return;
  }

  if (ownerId) {
    clearPersistedState();
  }

  const tabId = uuid();
  sessionStorage.setItem(TAB_ID_KEY, tabId);
  window.name = tabId;
};
